module.exports = __webpack_public_path__ + "img/uk-transport-accidents-male.6d86d48a.png";